<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  computed: {},
  filters: {},
  watch: {},

  created() {
    this.getSystemInfo()
  },
  mounted() {

  },

  methods: {
    // 获取系统配置
    getSystemInfo() {
      return this.$http({ url: `/system/base`, }).then(res => {
        console.log('获取系统配置', res);

        const { code, data, msg } = res
        if (code !== 200) return this.$toast.fail(msg)

        if (data.ico) {
          data.ico = data.ico.replace('http://', 'https://')
          document.querySelector('link[rel="icon"]').href = data.ico
        }
        if (data.name) document.title = data.name
      }).catch(() => { })
    },
  },
};

</script>

<style lang="less">
// #app {
//   max-width: 550px;
//   margin: 0 auto;
// }
</style>
